<button (click)='select()' class="btn btn-success">Select</button>
            <p-table #dt [columns]="cols"  [(selection)]="selectedContacts"  [value]="contacts" [paginator]="true" [rows]="20">


                <ng-template pTemplate="caption">
                    <div style="text-align: right">
                        <i class="fa fa-search"></i>
                        <input type="text" pInputText size="50" placeholder="Global Filter" (input)="dt.filterGlobal($event.target.value, 'contains')"
                            style="width:auto">
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th  style="width: 2em"></th>
                       
                        <th>
                            Prospect
                        </th>
                        <th *ngFor="let col of columns">
                            {{col.header}}

                        </th>
                        <th>
                            Status
                        </th>
                    </tr>
                    <tr>
                        <th style="width: 2em">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                       
                          </th>
                        <th style="width: 12em">
                            <input pInputText type="text" pInputText (input)="dt.filter($event.target.value, 'prospectId.raisonSocial', 'contains')">

                        </th>
                        <th *ngFor="let col of columns" [ngSwitch]="col.field" [style.width]='col.width'>
                            <input *ngSwitchCase="col.field" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')">
                        </th>
                        <th>
                            <input pInputText type="text" (input)="dt.filter($event.target.value, 'status', 'contains')">

                        </th>

                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr *ngIf="rowData.prospectId">
                        <td  style="width: 2em">
                            <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                          
                          
                          </td>
                        <td>
                            {{rowData.prospectId.raisonSocial}}
                        </td>

                        <td pEditableColumn *ngFor="let col of columns" [style.width]='col.width'>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                 </ng-template>
                                <ng-template pTemplate="output">
                                    {{rowData[col.field]}}
                                </ng-template>
                            </p-cellEditor>
                        </td>



                        <td>
                            <span class="badge " [style.background-color]=' rowData.prospectId.color '>{{rowData.prospectId.status}}</span>
                        </td>

                    </tr>
                </ng-template>
            </p-table>